import PlIcon from "../pl_icon";
import React, {useState} from "react";
import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";

import TtPosIcon from "./tt_pos_icon";
import {node} from "../../constants";
import {connect} from "react-redux";

const TtIcon = ({item, tttkitems}) => {

    // ACC
    let busstate = parseInt(item.accessorystate) | 0
    const buswait = parseInt(item.accessorywait) | 0

    var svgitems = [];

    svgitems.push(<circle key={"c1yy"} cx={p1*5} cy={p1*5} r={p1*2} stroke= {"#464646"} strokeWidth="1" fill={"#adadad"}/>)

    const corr = -30;

    // ACC
    let busangle = parseInt(item.ACC_DETAIL_CURR_ANGLE1DEG5) * 1.5 + corr
    if ( busangle < 0) {
        busangle += 360
    }

    const center = (p1 * 5)

    let bridge = []
    if( buswait) {

        let transformt = `rotate(${busangle},${center},${center})`;
        bridge.push(<line key={'l1'} x1={center - 15*p8} y1={center} x2={center + 15*p8}
                          y2={center} strokeWidth={"3"} stroke={"#464646"} transform={transformt}/>)
        bridge.push(<line  key={'l2'} x1={center - 3 * p2} y1={center+p8} x2={center + 3 * p2}
                          y2={center+p8} strokeWidth={"3"} stroke={"#464646"} transform={transformt}/>)



    } else {
        const curitem = tttkitems ? tttkitems.find(el => parseInt(el.asp) === parseInt(busstate)) : {ang: 0}

        if( curitem) {


            let a = parseInt(curitem.ang) + corr
            if( a < 0) {
                a += 360
            } else if( a > 360) {
                a -= 360
            }

            let transformt = `rotate(${a},${center},${center})`;
            bridge.push(<line key={'l13'}  x1={center - 2 * p1} y1={center} x2={center + 2 * p1}
                              y2={center} strokeWidth={"3"} stroke={"#464646"} transform={transformt}/>)
            bridge.push(<line key={'l14'}  x1={center - 3 * p2} y1={center+p8} x2={center + 3 * p2}
                              y2={center+p8} strokeWidth={"3"} stroke={"#464646"} transform={transformt}/>)

        }
    }

    let info = []
    //info.push(<text key={"tinfoxy"} x={p1} y={p1*9+p2}>{`asp: ${busstate} ang: ${busangle}`}</text>)

    let ttpositions = []
    /*if( item.positions) {
        for (let ttp of item.positions) {
            ttpositions.push(<TtPosIcon key={ttp.id} parentitem={item} item={ttp}/>)
        }
    }*/

    for (let ttp of tttkitems) {
        ttpositions.push(<TtPosIcon key={ttp.id} parentitem={item} item={ttp}/>)
    }

    return (
        <PlIcon item={item} width={p1 * 10} height={p1 * 10}>
            {svgitems}
            {ttpositions}
            {bridge}
            {info}
        </PlIcon>
    )
}

function mapStateToProps(state, other) {

    const itms = state.plan.items.filter(
        it => other.item.id === it.ttid && !isNaN(it.ang)
    )

    return {tttkitems: itms}
}

export default connect(mapStateToProps)(TtIcon)